var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.13 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35424b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.79,9.63a4.66,4.66,0,0,0-2.61-1.29l1.89-1.87a1.18,1.18,0,0,0,.35-.87V1.23A1.22,1.22,0,0,0,28.2,0h-27A1.23,1.23,0,0,0,0,1.23V5.54a1.21,1.21,0,0,0,.36.93L10.86,17V30.77h0a1.28,1.28,0,0,0,.27.79,1.23,1.23,0,0,0,1.74.15l5.16-4.27a1.21,1.21,0,0,0,.5-1V17l3.51-3.51a4.61,4.61,0,0,0,1.3,2.61,4.55,4.55,0,1,0,6.43-6.45ZM2.46,2.46H27V4.88H2.46V2.46Zm14,13.14h0a1.24,1.24,0,0,0-.36.88v9.4l-2.76,2.29V16.47A1.27,1.27,0,0,0,13,15.6L3.72,6.34h22L16.45,15.6ZM28.75,15h0a3.1,3.1,0,0,1-4.35,0,3.1,3.1,0,0,1-.9-2.17,3.54,3.54,0,0,1,.15-1l1.94-1.93a3.19,3.19,0,0,1,1-.16A3.08,3.08,0,0,1,28.75,15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.4dbfb769256cf97fd89e045e504b61c1.svg";
export { ForwardRef as ReactComponent };